import React, { useEffect, useState } from "react"
import Navbar from "./Navbar.jsx"
import "./index.css";
import firebase from './firebase.js';
import "firebase/storage";
import Project from "./Project.jsx";


export default function Home() {
  const [data,setData] = useState([])
  useEffect(()=>{
	async function getData() {
		setData([])
		const citiesRef = firebase.firestore().collection('projects');
		const snapshot = await citiesRef.get();
		if (snapshot.empty) {
			  return
		}  
		snapshot.forEach(doc => {
			setData((prev)=>{
				return [doc.data(),...prev]

			})
		});
	}
    getData()

  },[])

  return <div>
    <Navbar />
	<div className="project">
	{data.map((project,index) => {
		return <Project key={index*54} imgdata={project} />	
	})}
	</div>
  </div>
}
